// TODO: move to src/utils/values
const determineFirstNonNil = (...args) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const arg of args) {
    if (arg !== null && undefined !== arg) {
      return arg;
    }
  }

  return undefined;
};

// noinspection JSUnusedGlobalSymbols
export default determineFirstNonNil;
